module.exports = __webpack_public_path__ + "static/media/sleeping.477ca41c.png";